var DEFAULT_LANG = "zh-CN";
var DEFAULT_COOKIE_KEY = "x-hng";
var DEFAULT_SEARCH_KEY = "lang";
var DEFAULT_LOCAL_KEY = "PANDA_LANG";
var globalThis = function() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    // 全局对象不存在，抛出错误或者进行特殊处理
    return {};
}();
// 为确保获取到相对正确的cookie值，使用domain作为排序的依据
function getCookie(key) {
    var result = "";
    if (typeof document === "undefined") {
        return result;
    }
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var REDCode = /(%[0-9A-Z]{2})+/g;
    cookies.sort(function(a) {
        var _globalThis_location;
        return a.includes("domain=".concat((_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.hostname)) ? -1 : 0;
    });
    for(var i = 0; i < cookies.length; i++){
        var parts = cookies[i].split("=");
        try {
            var name = parts[0].replace(REDCode, decodeURIComponent);
            if (key === name) {
                result = parts.slice(1).join("=").replace(REDCode, decodeURIComponent);
                break;
            }
        } catch (e) {} // eslint-disable-line
    }
    return result;
}
/** 如果非x-hng则返回值，x-hng则返回lang部分的值 */ function getCookieLang(key) {
    if (typeof URLSearchParams === "undefined") {
        return "";
    }
    if (key === DEFAULT_COOKIE_KEY) {
        return new URLSearchParams(getCookie(DEFAULT_COOKIE_KEY)).get("lang") || DEFAULT_LANG;
    }
    return getCookie(key) || DEFAULT_LANG;
}
/** 获取当前环境os的lang */ var getOSLang = function() {
    var _globalThis__GATEWAY_PF_userPreference, _globalThis__GATEWAY_PF;
    return ((_globalThis__GATEWAY_PF = globalThis._GATEWAY_PF) === null || _globalThis__GATEWAY_PF === void 0 ? void 0 : (_globalThis__GATEWAY_PF_userPreference = _globalThis__GATEWAY_PF.userPreference) === null || _globalThis__GATEWAY_PF_userPreference === void 0 ? void 0 : _globalThis__GATEWAY_PF_userPreference.lang) || "";
};
var _langList = [
    {
        value: "zh-CN",
        s: [
            "zh-cn",
            "zh"
        ]
    },
    {
        value: "en-US",
        s: "en"
    },
    {
        value: "ja-JP",
        s: "ja"
    },
    {
        value: "ru-RU",
        s: "ru"
    },
    {
        value: "pt-PT",
        s: "pt"
    },
    {
        value: "fr-FR",
        s: "fr"
    },
    {
        value: "es-ES",
        s: "es"
    },
    {
        value: "zh-HK",
        s: "zh-hk"
    },
    {
        value: "zh-TW",
        s: "zh-tw"
    },
    {
        value: "ko-KR",
        s: "ko"
    },
    {
        value: "tr-TR",
        s: "tr"
    },
    {
        value: "pl-PL",
        s: "pl"
    },
    {
        value: "iw-IL",
        s: [
            "he",
            "iw"
        ]
    },
    {
        value: "it-IT",
        s: "it"
    },
    {
        value: "ar-SA",
        s: "ar"
    },
    {
        value: "cs-CZ",
        s: "cs"
    },
    {
        value: "da-DK",
        s: "da"
    },
    {
        value: "nl-NL",
        s: "nl"
    },
    {
        value: "de-DE",
        s: "de"
    },
    {
        value: "hi-IN",
        s: "hi"
    },
    {
        value: "hu-HU",
        s: "hu"
    },
    {
        value: "ms-MY",
        s: "ms"
    },
    {
        value: "in-ID",
        s: [
            "id",
            "in"
        ]
    },
    {
        value: "ro-RO",
        s: "ro"
    },
    {
        value: "sr-SA",
        s: "sr"
    },
    {
        value: "sk-SK",
        s: "sk"
    },
    {
        value: "sv-SE",
        s: "sv"
    },
    {
        value: "th-TH",
        s: "th"
    },
    {
        value: "uk-UA",
        s: "uk"
    },
    {
        value: "vi-VN",
        s: "vi"
    },
    {
        value: "pt-BR",
        s: "pt-br"
    },
    {
        value: "en-ID",
        s: [
            "en-id",
            "en"
        ]
    },
    {
        value: "en-MY",
        s: [
            "en-my",
            "en"
        ]
    },
    {
        value: "en-PH",
        s: [
            "en-ph",
            "en"
        ]
    },
    {
        value: "en-SG",
        s: [
            "en-sg",
            "en"
        ]
    },
    {
        value: "en-TH",
        s: [
            "en-th",
            "en"
        ]
    },
    {
        value: "en-VN",
        s: [
            "en-vn",
            "en"
        ]
    }
];
var getSearchLang = function() {
    if (typeof location !== "undefined" && location.search && typeof URLSearchParams !== "undefined") {
        var urlParams = new URLSearchParams(location.search);
        var searchLang = urlParams.get(DEFAULT_SEARCH_KEY) || "";
        if (searchLang) {
            return formatLang(searchLang);
        }
    }
    return "";
};
var getLocaleLang = function() {
    if (typeof localStorage !== "undefined") {
        var localeLang = localStorage.getItem(DEFAULT_LOCAL_KEY);
        if (localeLang) {
            return localeLang;
        }
    }
    return "";
};
/**
 * 语种格式转换：en-US，en_US, en_us, en 全部格式化为en-US
 * @param {string} locale 语种
 */ var formatLang = function(locale) {
    //  先匹配一轮, 先转成小写，并且将_转成-,然后进行匹配
    var _locale = locale.replace("_", "-");
    if (_locale.includes("-")) {
        _locale = _locale.split("-").map(function(item, index) {
            return index === 1 ? item.toUpperCase() : item;
        }).join("-");
    }
    var _slocale = _locale.toLowerCase();
    var theLang = _langList.find(function(item) {
        return item.value === _locale || (typeof item.s === "string" ? item.s === _slocale : item.s.includes(_slocale));
    });
    if (theLang) {
        return theLang.value;
    }
    // 处理特殊的 zh-Hans 和 zh-Hant
    if (locale.startsWith("zh-Hans")) {
        return "zh-CN";
    }
    if (locale.startsWith("zh-Hant")) {
        return locale === "zh-Hant-TW" ? "zh-TW" : "zh-HK";
    }
    // 处理 en-
    if (locale.startsWith("en-")) {
        return "en-US";
    }
    return locale;
};
var isMultiXhng = function() {
    var _document_cookie, _document;
    if (typeof document === "undefined") {
        return false;
    }
    var matchXhng = (_document = document) === null || _document === void 0 ? void 0 : (_document_cookie = _document.cookie) === null || _document_cookie === void 0 ? void 0 : _document_cookie.match(/x-hng/g);
    return matchXhng && Array.isArray(matchXhng) && matchXhng.length > 1;
};
var cacheBizLanguage = "";
/** 获取当前业务系统的语种（使用panda语种获取方案） */ export var getBizLanguage = function() {
    var _globalThis___PANDA, _globalThis___PANDA1, _globalThis___PANDA2, _globalThis___PANDA_langList, _globalThis___PANDA3, _globalThis___PANDA4;
    if (cacheBizLanguage) {
        return cacheBizLanguage;
    }
    // 取出来的值可能并不是语种，需要格式化
    var cookieKey = ((_globalThis___PANDA = globalThis.__PANDA) === null || _globalThis___PANDA === void 0 ? void 0 : _globalThis___PANDA.cookieKey) || DEFAULT_COOKIE_KEY;
    // window环境语种
    var envLang = globalThis.__PANDA_LANG || "";
    // 获取CDN给予的cookieKey, 如果没有默认走x-hng
    var customLang = cookieKey !== DEFAULT_COOKIE_KEY && getCookie(cookieKey) ? getCookieLang(cookieKey) : "";
    var xhngLang = cookieKey === DEFAULT_COOKIE_KEY && getCookie(DEFAULT_COOKIE_KEY) ? getCookieLang(DEFAULT_COOKIE_KEY) : "";
    var windowLang = (_globalThis___PANDA1 = globalThis.__PANDA) === null || _globalThis___PANDA1 === void 0 ? void 0 : _globalThis___PANDA1.lang;
    var searchLang = getSearchLang();
    var localLang = getLocaleLang();
    var defaultLang = (_globalThis___PANDA2 = globalThis.__PANDA) === null || _globalThis___PANDA2 === void 0 ? void 0 : _globalThis___PANDA2.defaultLang;
    var osLang = getOSLang();
    // 当x-hng冲突时（存在多个的情况） 提升localLang的权重
    var usedLang = envLang || searchLang || osLang || customLang || (isMultiXhng() ? localLang || xhngLang : xhngLang || localLang) || defaultLang || windowLang || DEFAULT_LANG;
    usedLang = formatLang(usedLang);
    // 如果全局设置的langList（允许语种），则最终会受限制
    if (((_globalThis___PANDA3 = globalThis.__PANDA) === null || _globalThis___PANDA3 === void 0 ? void 0 : (_globalThis___PANDA_langList = _globalThis___PANDA3.langList) === null || _globalThis___PANDA_langList === void 0 ? void 0 : _globalThis___PANDA_langList.length) && !((_globalThis___PANDA4 = globalThis.__PANDA) === null || _globalThis___PANDA4 === void 0 ? void 0 : _globalThis___PANDA4.langList.includes(usedLang))) {
        usedLang = globalThis.__PANDA.langList[0];
    }
    cacheBizLanguage = usedLang;
    return usedLang;
};
/** 获取Intl info的JSON字符传结果，如不支持intl返回空字符串 */ export var getIntlInfoStr = function() {
    try {
        return typeof Intl === "object" ? JSON.stringify(Intl.DateTimeFormat().resolvedOptions()) : "";
    } catch (e) {
        return "";
    }
};
/** 重置bizLanguage，用于测试 */ export function resetBizLanguageForTest() {
    cacheBizLanguage = "";
}

 //# sourceMappingURL=index.js.map